import gql from 'graphql-tag';
import { ADDRESS_VIEW_MODEL_FRAGMENT } from 'shared';

export const CREATE_CUSTOMER_ACCOUNT = gql`
  ${ADDRESS_VIEW_MODEL_FRAGMENT}
  mutation CreateCustomerAccount($input: CreateCustomerAccountInput!) {
    customer {
      result: createAccount(input: $input) {
        error
        success
        entity {
          id
          name
          phone
          billingAddress {
            ...AddressFields
          }
          deliveryAddress {
            ...AddressFields
          }
        }
      }
    }
  }
`;
